module.exports = __webpack_public_path__ + "img/dui.c09a21f0.png";